var React = require('react');

function CapitalMarkets (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#ffdb00","d":"M3.5 36.5h38v4h-38zM.5 40.5h44v4H.5z","key":0}),React.createElement("path",{"stroke":"#ffdb00","strokeLinecap":"round","d":"M22.448 2.51a.144.144 0 01.104 0l21.92 8.969a.186.186 0 01.017.007.073.073 0 01-.014.007.173.173 0 01-.055.007H.58a.173.173 0 01-.055-.007.075.075 0 01-.014-.007.18.18 0 01.016-.007l21.92-8.97z","key":1}),React.createElement("path",{"fill":"#ffdb00","d":"M7 11.75V37h31V11.75h-1V36H8V11.75H7z","key":2}),React.createElement("path",{"stroke":"#ffdb00","d":"M20.5 11.5h4v25h-4z","key":3}),React.createElement("path",{"stroke":"#ffdb00","d":"M11.5 11.5h22v25h-22z","key":4})]);
}

CapitalMarkets.defaultProps = {"fill":"none","viewBox":"0 0 45 45"};

module.exports = CapitalMarkets;

CapitalMarkets.default = CapitalMarkets;
